
/* Carga API (enviada por parámetro) por medio de fetch */

//*react- recursos
//fetch no ocupa carga 

//*componentes-utiles
import CargaAPI from "../../../api/cargaAPI/CargaAPI";

//*clases
import Container from "react-bootstrap/Container";

//*datos

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)

const myUrl= "https://api.github.com/repos/hadley/ggplot2/commits*" // por ejemplo

//*store's

//*archivos

//*vista
export default function Ejemplo(){
    
    return (
      <div >
          <h1>Ejemplo de carga de API fija por medio de Fetch:</h1>
          <h3>url ejemplo: {myUrl}</h3>
          <CargaAPI myAPI={myUrl} />
          <br/>

          <p id="verMsj">-------</p>
      </div>
    );
}
